import { registerPhone, sendTestMessage, syncNumber } from "../../features/onboarding/OnboardingServices";
import PhoneInput from "react-phone-number-input"
import "react-phone-number-input/style.css"
import { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import { toast } from "sonner";
import ModalLayout from "../../components/layouts/ModalLayout";

export default function RegiterBUttons() {
    const dispatch = useDispatch<AppDispatch>();

    const [testMessageModal, setTestMessageModal] = useState(false)
    const [mobileNumber, setMobileNumber] = useState("")
    const [actionLoading, setActionLoading] = useState<string | null>(null) // "register" | "sync" | "test"

    const handleRegisterPhone = async () => {
        setActionLoading("register")
        const result = await dispatch(registerPhone())
        if (registerPhone.fulfilled.match(result)) {
            toast.success("Phone registered successfully")
        } else {
            toast.error("Failed to register phone")
        }
        setActionLoading(null)
    }

    const handleSyncNumber = async () => {
        setActionLoading("sync")
        const result = await dispatch(syncNumber())
        if (syncNumber.fulfilled.match(result)) {
            toast.success("Number synced successfully")
        } else {
            toast.error("Failed to sync number")
        }
        setActionLoading(null)
    }

    const handleTestMessage = async () => {
        if (!mobileNumber.trim()) {
            toast.error("Mobile number required")
            return
        }

        setActionLoading("test")

        const cleanedNumber = mobileNumber.replace("+", "")

        const result = await dispatch(
            sendTestMessage({ mobileNumber: cleanedNumber })
        )

        if (sendTestMessage.fulfilled.match(result)) {
            toast.success("Test message sent")
            setTestMessageModal(false)
            setMobileNumber("")
        } else {
            toast.error("Failed to send test message")
        }
        setActionLoading(null)
    }
    return (
        <>
            <div className="flex flex-col items-end justify-end sm:flex-row gap-4 mt-6 sm:items-center">
                <button
                    onClick={handleRegisterPhone}
                    disabled={actionLoading === "register"}
                    className="flex items-center justify-center px-5 py-3 rounded-4xl bg-brand-blue-gradient text-white font-bold whitespace-nowrap disabled:opacity-60"
                >
                    {actionLoading === "register" ? "Registering..." : "Register Number"}
                </button>

                <button
                    onClick={handleSyncNumber}
                    disabled={actionLoading === "sync"}
                    className="flex items-center justify-center px-5 py-3 rounded-4xl bg-brand-blue-gradient text-white font-bold whitespace-nowrap disabled:opacity-60"
                >
                    {actionLoading === "sync" ? "Syncing..." : "Sync Number"}
                </button>

                {/* <button
                    onClick={() => setTestMessageModal(true)}
                    className="flex items-center justify-center px-5 py-3 rounded-4xl bg-brand-blue-gradient text-white font-bold whitespace-nowrap"
                >
                    Test Message
                </button> */}
            </div>
            {testMessageModal && (
                <ModalLayout onClose={() => { setTestMessageModal(false); setMobileNumber("") }}>
                    <div className="p-6 w-[350px] flex flex-col gap-4">

                        <h2 className="text-lg font-semibold">Send Test Message</h2>
                        <p className="text-sm text-text-secondary">Enter the number to send a test WhatsApp message</p>

                        <PhoneInput
                            value={mobileNumber}
                            onChange={(val) => setMobileNumber(val ?? "")}
                            defaultCountry="IN"
                            className="border border-gray-200 rounded-xl px-4 py-2.5 text-sm font-medium w-full"
                        />

                        <div className="flex gap-3 justify-end">
                            <button
                                onClick={() => { setTestMessageModal(false); setMobileNumber("") }}
                                className="px-5 py-2.5 rounded-xl border border-gray-200 text-text-secondary font-semibold text-sm hover:bg-gray-100"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleTestMessage}
                                disabled={actionLoading === "test"}
                                className="px-6 py-2.5 rounded-xl bg-brand-blue-gradient text-white font-bold text-sm disabled:opacity-60 flex items-center gap-2"
                            >
                                {actionLoading === "test"
                                    ? <><span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> Sending...</>
                                    : "Send"
                                }
                            </button>
                        </div>

                    </div>
                </ModalLayout>
            )}
        </>
    )
}
